/* Light/dark toggle. Mirrors lickity.click (next-themes): the "theme" key in
   localStorage is shared, so a choice on either side carries to the other.
   No stored choice = follow the system (html.auto-color). */
(function () {
    const root = document.documentElement;
    const darkQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const buttons = document.querySelectorAll('[data-lickity-theme-toggle]');

    // Ghost's comment buttons use the site accent (dark purple), which vanishes
    // on the dark page; brand pink keeps their white text readable.
    const ACCENT_LIGHT = '#1A0B2E';
    const ACCENT_DARK = '#D6006B';

    function isDark() {
        return root.classList.contains('dark-mode') ||
            (root.classList.contains('auto-color') && darkQuery.matches);
    }

    // Ghost comments (same-origin iframe) pick light/dark once at load. Keep
    // them in step when the reader or the system changes the theme.
    function syncComments(dark) {
        const frame = document.querySelector('.article-comments iframe');
        let display = null;
        try {
            display = frame && frame.contentDocument &&
                frame.contentDocument.querySelector('.ghost-display');
        } catch (e) {
            return;
        }
        if (!display) return;
        display.classList.toggle('dark', dark);
        display.style.setProperty('--gh-accent-color', dark ? ACCENT_DARK : ACCENT_LIGHT);

        // Ghost also bakes the load-time accent into inline styles on its buttons
        // and links, so repaint those for whichever theme is showing now.
        const doc = frame.contentDocument;
        if (doc.head && !doc.getElementById('lickity-comments-theme')) {
            const style = doc.createElement('style');
            style.id = 'lickity-comments-theme';
            style.textContent =
                '.ghost-display.dark [style*="background-color: rgb(26, 11, 46)"]{background-color:#D6006B!important}' +
                '.ghost-display.dark [style^="color: rgb(26, 11, 46)"],' +
                '.ghost-display.dark [style*="; color: rgb(26, 11, 46)"],' +
                '.ghost-display.dark [style^="color: rgb(214, 0, 107)"],' +
                '.ghost-display.dark [style*="; color: rgb(214, 0, 107)"]{color:#FF5CA8!important}' +
                '.ghost-display:not(.dark) [style*="background-color: rgb(214, 0, 107)"]{background-color:#1A0B2E!important}' +
                '.ghost-display:not(.dark) [style^="color: rgb(214, 0, 107)"],' +
                '.ghost-display:not(.dark) [style*="; color: rgb(214, 0, 107)"]{color:#1A0B2E!important}';
            doc.head.appendChild(style);
        }
    }

    function render() {
        const dark = isDark();
        buttons.forEach(function (button) {
            button.setAttribute('aria-pressed', dark ? 'true' : 'false');
        });
        syncComments(dark);
    }

    function apply(theme) {
        root.classList.remove('auto-color', 'dark-mode');
        if (theme === 'dark') root.classList.add('dark-mode');
        else if (theme !== 'light') root.classList.add('auto-color');
        render();
    }

    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            const next = isDark() ? 'light' : 'dark';
            apply(next);
            try {
                localStorage.setItem('theme', next);
            } catch (e) {
                // Private mode: the choice lasts for this page only.
            }
        });
    });

    // Another tab (blog or lickity.click) changed the theme.
    window.addEventListener('storage', function (event) {
        if (event.key === 'theme') apply(event.newValue);
    });

    // System switched light/dark while the page is open (CSS already follows it).
    if (darkQuery.addEventListener) darkQuery.addEventListener('change', render);
    else if (darkQuery.addListener) darkQuery.addListener(render);

    // The comments iframe renders after this script; sync it once it appears.
    const comments = document.querySelector('.article-comments');
    if (comments && window.MutationObserver) {
        let frameObserver = null;
        new MutationObserver(function () {
            const frame = comments.querySelector('iframe');
            if (frame && !frame.dataset.lickityThemeWatch) {
                frame.dataset.lickityThemeWatch = '1';
                frame.addEventListener('load', render);
            }
            const doc = frame && frame.contentDocument;
            if (doc && doc.body && !frameObserver) {
                // Ghost re-renders inside the frame; re-apply when it does.
                frameObserver = new MutationObserver(function () {
                    const display = doc.querySelector('.ghost-display');
                    if (display && display.classList.contains('dark') !== isDark()) render();
                });
                frameObserver.observe(doc.body, {childList: true, subtree: true});
            }
            render();
        }).observe(comments, {childList: true, subtree: true, attributes: true, attributeFilter: ['style']});
    }

    render();
})();
